import { createAction, props } from '@ngrx/store';
import { ClientDocumentsEffectsActionTypes } from './types';

export const navigated = createAction(
  ClientDocumentsEffectsActionTypes.Navigated,
  props<{ folderId: number | undefined }>()
);
